import { FormControl, IconButton, InputAdornment, InputLabel, MenuItem, Select, TextField } from '@mui/material';
import React, { useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import ListIcon from '@mui/icons-material/List';

export const frequencies = [
  { name: 'Every hour', value: '0 0 * * * *' },
  { name: 'Every 30 minutes', value: '0 0,30 * * * *' },
  { name: 'Every 15 minutes', value: '0 */15 * * * *' },
  { name: 'Every 10 minutes', value: '0 */10 * * * *' },
  { name: 'Every 5 minutes', value: '0 */5 * * * *' },
  { name: 'Every 1 minutes', value: '0 * * * * *' },
  { name: 'Cron expression', value: 'cron' },
];

type Props = {
  name: string;
  defaultValue?: string;
  required?: boolean;
  label?: string;
};

export default function Frequency({ name, defaultValue, required, label }: Props) {
  const { setValue, getValues } = useFormContext();
  const {
    field: { ref, onChange, onBlur, value },
    fieldState: { error },
  } = useController({
    name: name,
    defaultValue: defaultValue,
    rules: {
      required: required ? 'value required' : false,
      pattern: { value: /((((\d+,)+\d+|(\d+(\/|-)\d+)|\d+|\*) ?){5,7})/, message: 'invalid format' },
    },
  });

  const [showCustom, setShowCustom] = useState(() => {
    const value = getValues(name);
    return frequencies.map(({ value }) => value).indexOf(value) == -1;
  });

  const onSelectChange = (evt: any) => {
    if (evt.target.value == 'custom') {
      setShowCustom(true);
    } else {
      setShowCustom(false);
      onChange(evt);
    }
  };

  const onInputChange = (evt: any) => {
    onChange(evt.target.value);
  };

  const onClick = () => {
    setShowCustom(false);
    setValue(name, defaultValue);
  };
  return (
    <>
      {!showCustom && (
        <FormControl fullWidth>
          <InputLabel htmlFor="frequency" shrink>
            {label || 'Frequency'}
          </InputLabel>

          <Select label="frequency" value={value} onChange={onSelectChange} onBlur={onBlur}>
            {frequencies.map(({ name, value }) => (
              <MenuItem key={value} value={value}>
                {name}
              </MenuItem>
            ))}
            <MenuItem key="custom" value="custom">
              Custom
            </MenuItem>
          </Select>
        </FormControl>
      )}
      {showCustom && (
        <TextField
          label={label || 'Frequency'}
          inputRef={ref}
          onChange={onInputChange}
          value={value}
          onBlur={onBlur}
          error={!!error}
          required={!!required}
          helperText={error ? error.message : null}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={onClick}>
                  <ListIcon style={{ cursor: 'pointer' }} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      )}
    </>
  );
}
